import script from "./ApplicationsView.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplicationsView.vue?vue&type=script&setup=true&lang=js"

import "./ApplicationsView.vue?vue&type=style&index=0&id=057f12bc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-057f12bc"]])

export default __exports__